// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * How a telnet login is recognised. Each field is a case-insensitive substring;
 * an empty field means the built-in default.
 */
export class TelnetOptions implements flatbuffers.IUnpackableObject<TelnetOptionsT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TelnetOptions {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTelnetOptions(bb: flatbuffers.ByteBuffer, obj?: TelnetOptions): TelnetOptions {
    return (obj || new TelnetOptions()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTelnetOptions(
    bb: flatbuffers.ByteBuffer,
    obj?: TelnetOptions,
  ): TelnetOptions {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TelnetOptions()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Text asking for the user name. Default: any of `user name`, `username`,
   * `login`.
   */
  usernamePrompt(): string | null;
  usernamePrompt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  usernamePrompt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Text asking for the password. Default: `password`.
   */
  passwordPrompt(): string | null;
  passwordPrompt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  passwordPrompt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Text, seen after the password was sent, meaning the device is ready for
   * commands. Default: any of `>`, `#`, `$`, `successfully`, `logged in`,
   * `welcome`. Never looked for before the password is sent.
   */
  readyMarker(): string | null;
  readyMarker(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  readyMarker(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Text, seen after the password was sent, meaning the login was refused.
   * Default: any of `denied`, `incorrect`, `invalid`, `fail`.
   */
  failureMarker(): string | null;
  failureMarker(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  failureMarker(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startTelnetOptions(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addUsernamePrompt(builder: flatbuffers.Builder, usernamePromptOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, usernamePromptOffset, 0);
  }

  static addPasswordPrompt(builder: flatbuffers.Builder, passwordPromptOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, passwordPromptOffset, 0);
  }

  static addReadyMarker(builder: flatbuffers.Builder, readyMarkerOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, readyMarkerOffset, 0);
  }

  static addFailureMarker(builder: flatbuffers.Builder, failureMarkerOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, failureMarkerOffset, 0);
  }

  static endTelnetOptions(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createTelnetOptions(
    builder: flatbuffers.Builder,
    usernamePromptOffset: flatbuffers.Offset,
    passwordPromptOffset: flatbuffers.Offset,
    readyMarkerOffset: flatbuffers.Offset,
    failureMarkerOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    TelnetOptions.startTelnetOptions(builder);
    TelnetOptions.addUsernamePrompt(builder, usernamePromptOffset);
    TelnetOptions.addPasswordPrompt(builder, passwordPromptOffset);
    TelnetOptions.addReadyMarker(builder, readyMarkerOffset);
    TelnetOptions.addFailureMarker(builder, failureMarkerOffset);
    return TelnetOptions.endTelnetOptions(builder);
  }

  unpack(): TelnetOptionsT {
    return new TelnetOptionsT(
      this.usernamePrompt(),
      this.passwordPrompt(),
      this.readyMarker(),
      this.failureMarker(),
    );
  }

  unpackTo(_o: TelnetOptionsT): void {
    _o.usernamePrompt = this.usernamePrompt();
    _o.passwordPrompt = this.passwordPrompt();
    _o.readyMarker = this.readyMarker();
    _o.failureMarker = this.failureMarker();
  }

  unpackFields(...fields: string[]): TelnetOptionsT {
    const t = new TelnetOptionsT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("username_prompt")) {
      t.usernamePrompt = this.usernamePrompt();
    }
    if (fieldSet.has("password_prompt")) {
      t.passwordPrompt = this.passwordPrompt();
    }
    if (fieldSet.has("ready_marker")) {
      t.readyMarker = this.readyMarker();
    }
    if (fieldSet.has("failure_marker")) {
      t.failureMarker = this.failureMarker();
    }
    return t;
  }
}

export class TelnetOptionsT implements flatbuffers.IGeneratedObject {
  constructor(
    public usernamePrompt: string | Uint8Array | null = null,
    public passwordPrompt: string | Uint8Array | null = null,
    public readyMarker: string | Uint8Array | null = null,
    public failureMarker: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const usernamePrompt =
      this.usernamePrompt !== null ? builder.createString(this.usernamePrompt!) : 0;
    const passwordPrompt =
      this.passwordPrompt !== null ? builder.createString(this.passwordPrompt!) : 0;
    const readyMarker = this.readyMarker !== null ? builder.createString(this.readyMarker!) : 0;
    const failureMarker =
      this.failureMarker !== null ? builder.createString(this.failureMarker!) : 0;

    return TelnetOptions.createTelnetOptions(
      builder,
      usernamePrompt,
      passwordPrompt,
      readyMarker,
      failureMarker,
    );
  }

  clone(): TelnetOptionsT {
    const obj = new TelnetOptionsT();
    obj.usernamePrompt = this.usernamePrompt;
    obj.passwordPrompt = this.passwordPrompt;
    obj.readyMarker = this.readyMarker;
    obj.failureMarker = this.failureMarker;
    return obj;
  }

  equals(other: TelnetOptionsT): boolean {
    if (this.usernamePrompt !== other.usernamePrompt) return false;
    if (this.passwordPrompt !== other.passwordPrompt) return false;
    if (this.readyMarker !== other.readyMarker) return false;
    if (this.failureMarker !== other.failureMarker) return false;
    return true;
  }
}

export function verifyTelnetOptions(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
